module.exports = __webpack_public_path__ + "static/media/logo-small.678d4f5c.svg";